import * as v from "valibot";
import { baseVals, defineValidation } from "../../common/validation.common";
import { PaymentMethodEnum } from "../../data/enums";
import { paymentMethods } from "../../data/payment.data";

export namespace FinancePaymentValidation {
    export const Create = defineValidation(
        v.object({
            paymentMethod: v.pipe(v.string(), v.picklist(paymentMethods)),
        }),
    );

    export const Update = defineValidation(
        v.object({
            method: v.picklist(PaymentMethodEnum.values),
            account: baseVals.string(),
            // notes: v.optional(baseVals.string()),
        }),
    );
}
